<template>
<div class="content">
  <q-card>
    <q-card-title>
      <div class="row">
        <div class="col-12">
          {{$t('global.WorkResourcesDefineManage')}} 
        </div>
      </div> 
    </q-card-title>
    <q-card-separator />
    <div class="row">
      <div class="col-xs-12 col-sm-4 content">
        <div id="new" @click="newWork()">{{$t('global.Work')}}</div>
        <q-tree
          :nodes="workTree" 
          node-key="IdResource"
          :selected.sync="selectedWork"
          :expanded.sync="propsExpandedWork"
        >
        </q-tree>
      </div>
      <div class="col-12 content">
        <span>{{$t('global.Edit')}} <q-toggle v-model="newResource" :label="$t('global.NewEntry')" /></span>
      </div>
    </div>
    <div v-if="selectedWork && newResource == false" class="row>"> 
      <div class="col-xs-12 col-sm-4 content">
        <q-card >
          <q-card-title>
            {{$t('global.WorkResourceEdit')}} 
            <q-btn class="float-right" icon="cached" @click="WorkUpdate()" color="primary" :label="$t('global.Save')" />
            <q-btn v-if="workEdit.InUse == false && workEdit.NoChild" color="secondary"  @click="WorkDelete()" class="on-left" :flat="true" :label="$t('global.Delete')" />
            <!-- Work in Progress to dublicate <q-btn  @click="WorkCopy()" class="on-left" color="secondary" :flat="true" label="Copy" /> -->
            
          </q-card-title>
          <q-card-separator />
          <div class="row">
            <div class="col-12 content">
              <q-input
               v-if="!workEdit.disabled"
               class="content" 
               v-model="workEdit.Label" 
               :stack-label="$t('global.Description')"
              />
              <div class="content">
                <q-radio disable="true" v-model="editIdType" val="2" :label="$t('global.Workgroup')" /> &nbsp;&nbsp;
                <q-radio disable="true" v-model="editIdType" val="3" :label="$t('global.Resource')" /> &nbsp;&nbsp;
                <q-radio disable="true" v-model="editIdType" val="1" :label="$t('global.AllocableWork')" /> 
              </div>
              
              <q-select
                v-if="editIdType == 3"
                v-model="workEdit.IdResourceTemplate"
                :float-label="$t('global.ResourceTemlate')"
                :options="selectTemplateOptions"
                :display-value="DisplayCategory"
              />  
    
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <div v-if="newResource == true" class="row>"> 
      <div class="col-xs-12 col-sm-4 content">
        <q-card>
          <q-card-title>
            {{$t('global.DefineNewWorkResource')}}<span v-if="selectedWork">, {{$t('global.Under')}}: {{workEdit.Label}}</span>
            <q-btn class="float-right" icon="cached" @click="newWork()" color="primary" :label="$t('global.Save')" /> 
          </q-card-title>
          <q-card-separator />
          <div class="row">
            <div class="col-12 content">
              <div class="content">
                <q-radio v-model="newOption" val="2" :label="$t('global.Workgroup')" /> &nbsp;&nbsp;
                <q-radio v-model="newOption" val="3" :label="$t('global.Resource')" /> &nbsp;&nbsp;
                <q-radio v-model="newOption" val="1" :label="$t('global.AllocableWork')" /> 
              </div>
              <q-input 
                v-if="newOption != 3"
                class="content" 
                v-model="workNew.Label" 
                :stack-label="$t('global.Description')" 
              />
              <q-select
                v-if="newOption == 3"
                v-model="workNew.IdResourceTemplate"
                :float-label="$t('global.ResourceTemlate')"
                :options="selectTemplateOptions"
                :display-value="DisplayCategory"
              />
            </div>
          </div>
        </q-card>
      </div>
    </div>



    </q-card>
</div>

</template>

<script>
import axios from 'axios'
import qs from 'qs'

import {eventBus} from '../../main'


export default {
  name: 'DistributeWork',
  data: function () {
    return {
      editIdType: null,
      newOption:null,
      form: {
        SessionId: null,
        action: 'GeoRegionsTree',
        IdLanguage: 1
      },
      selectedWork: null,
      propsExpandedWork: [],
      workTree: [],
      workTreeFlat: [],
      workEdit: null,
      newResource: false, 
      workNew: { Label: '', CostFix: null, 
        CostHa: null, CostPerHour: null, IdParent: null, 
        QuartalPriority: null, disabled: false },
      selectTemplateOptions: [],
      selectedTemplate: null
    }
  },
  methods: {
    loadResourceTree(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getResourceTree"
      this.form.OnlyWorkSelectable = false
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
              this.workTree = response.data
              this.makeWorkTreeFlat(response.data)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    loadResourceTemplate(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getResourceTemplates"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              response.data.forEach(rsTemp => {
                let label = rsTemp.label 
                let CostFix = ''
                if (rsTemp.CostFix != null){
                  CostFix = ', ' + this.$t('global.CostFix') + ': ' + this.decFormat(rsTemp.CostFix)
                } 
                let CostPerHour = ''
                if (rsTemp.CostPerHour != null){
                  CostPerHour = ', ' + this.$t('global.CostHour') + ': ' + this.decFormat(rsTemp.CostPerHour)
                } 
                let CostHa = ''
                if (rsTemp.CostHa != null){
                  CostHa = ', ' + this.$t('global.CostHa') + ': ' + this.decFormat(rsTemp.CostHa)
                } 
                if (rsTemp.ResourceCostFlexible){
                  label += ', ' + this.$t('global.ResourceCostFlexible')
                }else{
                  label +=  CostFix + CostPerHour + CostHa
                }
                this.selectTemplateOptions.push({value: rsTemp.value, label: label})
              })
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    cloneWorkTree(elements){ 
      elements.forEach(element => {
        var noChild = false
        if(element.children.length == 0){
          noChild = true
        }
        alert(element.label)
        this.cloneWorkTree(element.children)
      })
    },
    makeWorkTreeFlat(elements){ 
      elements.forEach(element => {
        var noChild = false
        if(element.children.length == 0){
          noChild = true
        }
        this.workTreeFlat[element.IdResource] = { Label: element.label, CostFix: element.CostFix, 
        CostHa: element.CostHa, CostPerHour: element.CostPerHour, IdParent: element.IdParent, 
        QuartalPriority: element.QuartalPriority, disabled: element.disabled, 
        IdResourceTemplate: element.IdResourceTemplate,
        IdResource: element.IdResource, InUse: element.InUse, NoChild: noChild, Children: element.children, IdType: element.IdType }
        //overwrite disabled so all nodes can be selected
        element.disabled = false
        //recursive call:
        this.makeWorkTreeFlat(element.children)
      })
    },
    newWork(){
      
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "InsertResource"
      if(this.workEdit != null){
        this.workNew.IdParent = this.workEdit.IdResource
      }
      else{
         this.workNew.IdParent = null
      }
      
      this.workNew.IdType = this.newOption

      this.form.resource = this.workNew
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                this.loadResourceTree()
                this.$q.notify({ message: this.$t('global.NewEntry'), type: 'positive' })
                if(this.workNew.IdParent != null){
                  //Open Parent Node hope that does not cause any issues
                  this.propsExpandedWork.push(this.workNew.IdParent)
                }
                eventBus.$emit('WorkAssignUpdate', null)
              }
              else{
                this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    WorkUpdate(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "UpdateResource"
      this.form.resource = this.workEdit
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                this.loadResourceTree()
                this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
                eventBus.$emit('WorkAssignUpdate', null)
              }
              else{
                this.$q.notify('Something Wrong.')
              }

          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    WorkCopy(){
      var nrNode = this.workEdit.IdResource
      var Children = this.workTreeFlat[nrNode].Children
      this.cloneWorkTree(Children)
      console.log(Children)
    },
    WorkDelete(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "DeleteResource"
      this.form.IdResource = this.workEdit.IdResource
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                this.loadResourceTree()
                this.selectedWork = null
                this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
                eventBus.$emit('WorkAssignUpdate', null)
              }
              else{
                this.$q.notify('Something Wrong.')
              }
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    decFormat(val) {
      return val.toFixed(2)
    },
  },
    watch: {
    selectedWork: function (val) {
      this.workEdit = this.workTreeFlat[val]
      this.editIdType = this.workEdit.IdType.toString()
    },
    selectedTemplate: function(val){
      //work in progress, get data of selected template, to be displayed later
      var template = this.selectTemplateOptions.find(obj => obj.value == val);
    }
  },
  created () {
    this.loadResourceTree()
    this.loadResourceTemplate()
    eventBus.$on('dataChange', (data) => {
      this.loadResourceTemplate()
    })
  },
  computed: {
  },
}
</script>
<style scoped>
.content{
  padding: 10px;
}
.titel{
  text-align: center;
}
.confirm{
  margin-top: 10px
}
</style>